<!--  -->
<template>
  <div>
    <!-- <scale-box
      style="transform-origin: 0 0"
      :width="1920"
      :height="1080"
      :isFlat="true"
    > -->
    <div class="content">
      <div class="header">
        <HeaderNav
          :identification="identification"
          class="m360"
          @toDetail="toDetail"
        />
        <div style="flex: 1">
          <img :src="isUrl" alt="" v-if="isUrl" class="headerUrl" />
        </div>
        <div class="tail" v-if="identification == 0">
          <!-- <div v-for="(item, index) in navList" :key="index" class="every">
              {{ item.name }}
            </div> -->
          <img src="@/assets/navigation.png" alt="" />
        </div>
        <div class="ident-items" v-if="identification == 3">
          <div
            v-for="(item, i) in BrieList"
            :key="i"
            @click="identDetail(item, i)"
            :class="['ident', { active: idenCode == item.idenCode }]"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="main">
        <HomeIndex v-if="identification == 0" />
        <product v-if="identification == 1" />
        <scheme v-if="identification == 2" />
        <BriefIntroduction :idenCode="idenCode" v-if="identification == 3" />
        <partner :idenCode="idenCode" v-if="identification == 4" />
        <anxinYun :idenCode="idenCode" v-if="identification == 5" />
      </div>

      <FooterBTn />
    </div>
    <!-- </scale-box> -->
  </div>
</template>

<script>
import HeaderNav from "@/components/HeaderNav.vue";
import product from "@/components/product/index.vue";
import HomeIndex from "@/components/home/index.vue";
import scheme from "@/components/scheme/index.vue";
import ScaleBox from "vue2-scale-box";
import BriefIntroduction from "@/components/BriefIntroduction/index.vue";
import FooterBTn from "@/components/FooterBtn.vue";
import information from "@/components/information/index.vue";
import partner from "@/components/partner/index.vue";
import anxinYun from "@/components/anxinCloud/index.vue";
export default {
  components: {
    HeaderNav,
    ScaleBox,
    product,
    scheme,
    HomeIndex,
    BriefIntroduction,
    FooterBTn,
    partner,
    information,
    anxinYun,
  },
  data() {
    return {
      identification: 0,
      idenCode: 1,
      // navList: [
      //   { name: "自主接单，即时到账" },
      //   { name: "在线学习，提技增收" },
      //   { name: "精准匹配、有安全保障" },
      //   { name: "海量资源，面向全国" },
      // ],
      certificates: [
        { url: require("@/assets/Rectangle.png"), code: 0 },
        { url: require("@/assets/Slice12.png"), code: 3 },
        { url: require("@/assets/Slice11.png"), code: 6 },
        { url: require("@/assets/Slice10.png"), code: 4 },
      ],
      BrieList: [
        { name: "企业介绍", idenCode: 1 },
        // { name: "合作伙伴", idenCode: 2 },
        { name: "最新资讯", idenCode: 3 },
      ],
    };
  },
  computed: {
    isUrl() {
      let url = "";
      let obj = this.certificates.find(
        (item) => item.code == this.identification
      );
      if (obj) {
        url = obj.url;
      }
      if (this.idenCode == 3 && this.identification == 3) {
        url = require("@/assets/Slice11.png");
      }
      return url;
    },
  },
  watch: {},
  methods: {
    toDetail(event) {
      this.identification = event;
    },
    identDetail(event) {
      this.idenCode = event.idenCode;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: PingFang SC, PingFang SC;
  position: relative;
  display: flex;
  flex-direction: column;
}
.m360 {
  height: 64px;
  position: absolute;
  top: 0;
  left: 360px;
  z-index: 199;
  right: 360px;
}
/* 在小屏幕上使用单列布局 */
@media (max-width: 768px) {
  .m360 {
    right: 240px;
    left: 240px;
  }
}
.header {
  width: 100%;
  margin-bottom: -5px;
  .headerUrl {
    width: 100%;
    height: 560px;
  }
  display: flex;
  flex-direction: column;
  z-index: 1;
  position: relative;
  .tail {
    width: 100%;
    // background: rgba(255, 255, 255, 0.5);
    // padding: 22px 360px;
    z-index: 199;
    display: flex;
    position: absolute;
    position: absolute;
    left: 0;
    z-index: 199;
    bottom: 0px;
    z-index: 199;
    img {
      width: 100%;
      height: 64px;
    }
  }
}
.main {
  // margin-top: 80px;
  flex: 1;
}

.ident-items {
  display: flex;
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
  padding: 22px 0;
  z-index: 199;
  display: flex;
  position: absolute;
  left: 0;
  z-index: 199;
  bottom: 0;
  .ident {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #141414;
    // margin-right: 460px;
    // width: 50%;
    text-align: left;
    margin-left: 554px;
    cursor: pointer;
  }

  .active {
    font-weight: bold !important;
    font-size: 20px !important;
    color: #1c87ff !important;
    position: relative;
  }

  .active::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 30%;
    width: 40px;
    border-radius: 50px;
    height: 4px;
    background-color: #1c87ff;
  }
}

@media (max-width: 768px) {
  .ident-items {
    height: 40px;
    .ident {
      margin-left: 440px;
    }

    .active::after {
      bottom: 0;
    }
  }
}
</style>
